export default __webpack_public_path__ + "static/media/info.56ffcff2.svg";